import { Icon, IconButton } from "@keybr/widget";
import { mdiArrowCollapseAll, mdiArrowExpandAll, mdiFormatFont,mdiNotificationClearAll,mdiDelete } from "@mdi/js";
import { type ReactNode } from "react";
import { defineMessage, useIntl } from "react-intl";
import { useTheme } from "./context.tsx";
import { COLORS, FONTS } from "./options.tsx";
import * as styles from "./ThemeSwitcher.module.less";

export function ThemeSwitcher(): ReactNode {
  const clearClick = ()=>{
  var confirmed = confirm("该操作将会清空打字记录，如果重置不成功，请强刷浏览器缓存，然后重新尝试，确定要执行这个操作吗？");
        if (confirmed) {
          localStorage.clear();
          let request = window.indexedDB.open('history');
          request.onsuccess = function (event) {
            let db = event.target.result;
            db.close();
            let deleteRequest = window.indexedDB.deleteDatabase('history');
            deleteRequest.onsuccess = function () {
              console.log('Database deleted successfully');
              location.reload();
            };

            deleteRequest.onerror = function () {
              console.error('Error deleting database');
            };
          };

          request.onerror = function (event) {
            console.error('Error opening database:', event.target.error);
          };
        }
 }
  return (
    <div className={styles.themeSwitcher}>
      <ClearButton style={{marginRight:'3px'}}  /> <span onClick={clearClick} style={{cursor: 'pointer'}}  >重置</span>
     { /* <ColorButton /> */ }
     { /* <FontButton /> */}
     { /*  <FullscreenButton /> */ }
    </div>
  );
}

ThemeSwitcher.selector = `.${styles.themeSwitcher}`;

function FullscreenButton(): ReactNode {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  switch (theme.fullscreenState) {
    case true:
      return (
        <IconButton
          icon={<Icon shape={mdiArrowCollapseAll} />}
          title={formatMessage(
            defineMessage({
              id: "theme.exitFullscreen.description",
              defaultMessage: "Exit full-screen mode.",
            }),
          )}
          onClick={() => {
            theme.toggleFullscreen();
          }}
        />
      );
    case false:
      return (
        <IconButton
          icon={<Icon shape={mdiArrowExpandAll} />}
          title={formatMessage(
            defineMessage({
              id: "theme.enterFullscreen.description",
              defaultMessage: "Enter full-screen mode.",
            }),
          )}
          onClick={() => {
            theme.toggleFullscreen();
          }}
        >测试</IconButton>
      );
    default:
      return (
        <IconButton
          icon={<Icon shape={mdiNotificationClearAll} />}
          title={'清空打字记录'}
        />
      );
  }
}

function ClearButton(): ReactNode {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const option = COLORS.findOption(theme.color);
  const next = COLORS.findNext(option);
  return (
    <IconButton
      icon={<Icon shape={mdiDelete} />}
      style={{display:'block'}}
      title={'清空打字记录'}
      onClick={() => {
	var confirmed = confirm("该操作将会清空打字记录，如果重置不成功，请强刷浏览器缓存，然后重新尝试，确定要执行这个操作吗？");
	if (confirmed) {
	localStorage.clear();
        let request = window.indexedDB.open('history');
        request.onsuccess = function (event) {
          let db = event.target.result;
          db.close();
          let deleteRequest = window.indexedDB.deleteDatabase('history');
          deleteRequest.onsuccess = function () {
            console.log('Database deleted successfully');
	    location.reload();
          };

          deleteRequest.onerror = function () {
            console.error('Error deleting database');
          };
        };

        request.onerror = function (event) {
          console.error('Error opening database:', event.target.error);
        };
	}
      }}
    />
  );
}

function ColorButton(): ReactNode {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const option = COLORS.findOption(theme.color);
  const next = COLORS.findNext(option);
  return (
    <IconButton
      icon={option.icon}
      title={formatMessage(
        defineMessage({
          id: "theme.switchTheme.description",
          defaultMessage: "Switch to theme {name}.",
        }),
        {
          name: next.title,
        },
      )}
      onClick={() => {
        theme.switchColor(next.id);
      }}
    />
  );
}

function FontButton(): ReactNode {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const option = FONTS.findOption(theme.font);
  const next = FONTS.findNext(option);
  return (
    <IconButton
      icon={<Icon shape={mdiFormatFont} />}
      title={formatMessage(
        defineMessage({
          id: "theme.switchTheme.description",
          defaultMessage: "Switch to theme {name}.",
        }),
        {
          name: next.title,
        },
      )}
      onClick={() => {
        theme.switchFont(next.id);
      }}
    />
  );
}
